import { createContext, useContext, useLayoutEffect, useRef } from 'react';
import type { AgentPageReader, createAgentPageContextRegistry } from 'services/agent/page-context';
import { useLocation } from 'views/Multitab/Router';

export const AgentPageReadersContext = createContext<ReturnType<
  typeof createAgentPageContextRegistry
> | null>(null);

export function useAgentPageReader(read: AgentPageReader) {
  const registry = useContext(AgentPageReadersContext);
  const { pathname } = useLocation();
  const latest = useRef(read);
  useLayoutEffect(() => {
    latest.current = read;
  });
  useLayoutEffect(() => registry?.register(pathname, () => latest.current()), [registry, pathname]);
}
